export default {
    name: "長鹿観光休博園",
    language: {
        Chinese: '中国語',
        English: '英語',
        korea: '韓国人',
        Japanese: '日本語'
    },
    nav: {
        index: "トップページ",
        theme: "9、テーマパーク",
        restaurant: "レストラン",
        activity: "テーマ活動",
        performance: "素晴らしい演繹",
        service: "観光客サービス",
        online: "ネット予約"
    },
    service: {
        work_time: "営業時間",
        traffic: "交通案内",
        map_title: "園内地図",
        problems_title: "よくある質問、",
        notice_title: "観光客注意事項",
        complaints_title: "アドバイスとクレーム",
        video_title: "ビデオコーナー",
        discount_title: "割引キャンペン情報",
        tour_server: 'ガイドサービス',
        security_check:'偽造防止照会'
    },
    theme: [
        "長鹿絶叫島",
        "童話動物王国",
        "長鹿リゾート",
        "軍事テーマ公園",
        "農家楽テーマ公園",
        "海底世界テーマ公園",
        "湿地テーマ公園"],
    footerNav: [
        '人材募集',
        'ニュースセンター',
        '連絡先',
        '長鹿について',
        '会社紹介',
        '友情リンク',
        '励まし分享 '],
    theme_bg_tit: "テーマ背景",
    cart: "ショッピングカートに乗り込む",
    search_title: "グローバルサーチ",
    service_tel: "客服熱綫", //客服电话热线
    address: "住所", //地址
    address_content: "広東省仏山市順徳倫教三洲に東路建設",
    activity: ['最近の活動', '特別割引', 'きっぷうり活動'],
    base_info: '基本情報',//基本信息
    traffic_type: [
        "自車路線",
        "バス路線",
        "ライトレール路線",
        '飛行場路線'
    ],
    resume: "個人の履歴",//尾页 招贤纳士 个人履历
    shop_cart: "ショッピングカート",//购物车名词
    traffic_system: "[オピニオン]長鹿観光博園の交通照会システム",
    map_download: "地図のダウンロード",
    order: '注文情報確認',
    pay_info: "支払いが成功する",
    upload: "年カードの資料をアップロードします",
    personal: "個人センター",
    card_bag: "私のカバン",
    login: "ろぐおん",
    register: "登録する",
    join: "私の応募",
    my_order: "私の注文",
    tourist_map: "導遊図",
    work_type: [
        '社会募集',
        '研修生募集',
        '実習募集',
        'アルバイト募集'
    ],
    enter_key: "キーワードを入力してください",// 招贤纳士的占位符
    time_notice: "イベントのパフォーマンス時間をもっと多く得ることができるように、お問い合わせの電話をかけることができます，",
    consult_tel: "問い合わせ電話",
    online_type: [
        "チケット予約",
        "ホテル予約、",
        "長鹿年間カード",
        "特恵販促"
    ],
    placeholder_verity: "検証コードを入力してください",
    get_verity: "検証コードを取得する",
    account: "アカウント登録",
    without_code: "めんみつ登録",
    placeholder_code: "アカウントを入力してください",
    placeholder_psd: "6 ~ 20ビットのパスワードを入力してください",
    placeholder_img_verity: "図形検証コードを入力してください",
    placeholder_repeat_psd: "パスワードを再度入力してください",
    submit: "掛る",
    send_code: "検証コードを送信する",
    please_login: "どうぞお入りください",
    experience: "労働体験",
    department: "作業部門",
    education: "学歴の要求",
    recruitment: "採用類型",
    recruitment_number: "採用人数",
    release_time: "リリース時期",
    work_address: "勤務地",
    employ: "応募します",
    month: "つき",
    newsNav: ["会社ニュース", "園内公告"],
    view_count: "閲覧回数",
    recent: "最近のニュース",
    education_bg: "教育の背景",
    detail_address: "詳しい住所",
    save: "保存する",
    submit_applications: "申請を出す",
    certificate: "証明書",
    tip: "次のステップを実行する前に必ず記入して保存してください",
    placeholder_c: "検索する内容を入力してください",
    contact_tel: "電話をつなぐ",
    switchboard: "ちゅうおうおふぃす",
    complaints_hotline: "クレーム電話",
    Medical_phone: "医療電話",
    house_phone: "消防電話",
    all_address: "広東省仏山市順徳倫教三洲建設東路長鹿観光休博園（順徳倫教三洲と番禺沙湾の境にある）",
    company: "広東長鹿観光休憩博覧園有限公司",
    hotline: "問い合わせ電話",
    hotline_tip: "(24時間コールサービス)",
    placeholder_location: "ホームポジションを入力してください",
    notice_tip: "以上の注意事項をお守りください。ご不便をかけたことがありましたら、ご理解ください。楽しい旅を過ごしましょう。",
    complaints_type: "クレームの種類",
    select: "選択してください",
    phone: "携帯電話番号",
    placeholder_suggestion: "あなたの意見を書いてください",
    sure_submit: "確認提出",
    activity_time: "活動時間",
    still_time: "イベント終了時間まで残っています",
    start_time: "イベント开始时间は",
    grab_num: "すでに数量を奪い合った",
    all: "ども",
    piece: "枚",
    select_time: "移動日を選択してください",
    select_grab: "チケットの枚数を選んでください",
    activity_detail: "活動の詳細",
    past: "もう終わった",
    progress: "進行中",
    to: "至り",
    show_time: "ショータイム",
    placeholder_key: "キーワードで検索する",
    job_title: "役職名",
    depart: "所属部門",
    personal_data: "個人情報",
    head_portrait: "顔",
    compellation: "名前",
    sex: "性别",
    sex_men: "男",
    sex_women: "女",
    birthday: "出生年月",
    contact_way: "連絡先",
    email: "メールアドレス",
    address_now: "現住所",
    height: "身長",
    weight: "体重が",
    academic: "最高学歴",
    learning: "学習形式",
    academic_lists:[
        "小学校",
        "中学",
        "実家から",
        "高校",
        "専門大学",
        "学部",
        "大学院生",
        "博士は、"
    ],
    learning_lists:[
        "定時制",
        "成人修学能力試験",
        "遠隔教育",
        "たいとう",
        "国家開発大学"
    ],
    job_intention: "求職意向",
    expected_salary: "月給を望む",
    arrival_time: "勤務時間",
    next: "次のステップ",
    placeholder_name: "氏名を入力してください",
    placeholder_birth: "生年月日を入力してください",
    placeholder_mail: "メールアドレスを入力してください",
    placeholder_way: "連絡先を入力してください",
    placeholder_address: "住所を入力してください",
    placeholder_height: "身長を入力してください",
    placeholder_weight: "体重を入力してください",
    placeholder_salary: "希望税引き前月給を入力してください",
    placeholder_arrival: "勤務時間を選んでください",
    upload_img: "アバタを伝う",
    upload_detail: "*親と子どもが一緒に撮った写真を掲載",
    idCard: "身分番号",
    placeholder_real_name: "実名を入力してください",
    placeholder_idCard: "住民登録番号を記入してください",
    placeholder_phone: "携帯電話の番号を記入してください",
    error_msg: "ネットワークエラー、管理者に連絡してください",
    discount: "優待券",
    date: "期日",
    score: "ふん",
    total_score: "積分の総数",
    unused_score: "可用积分",
    used_score: "積分を用いる",
    detail_info: "詳しい情報",
    integration: "ぜひ必要",
    order_num: "注文番号:",
    use_hour: "使用時間:",
    contact_person: "連絡先情報:",
    all_sum: "合計:",
    personal_info: "個人情報",
    certificate_card: "証明番号",
    age: "よさん",
    mail: "郵箱",
    submit_data: "個人情報の提出",
    placeholder_age: "年齢を入力してください",
    placeholder_card: "証明書番号を入力してください",
    placeholder_tel: "携帯番号を入力してください",
    join_grab : "乗っ取りに入る",
    crazy: "ふうきょう",
    grabbing: "チケット中" ,
    notYet: "まだ",
    start: "始める",
    IC_case:'粤工商备',
    G_case :"粤ICP备",
    home_axios: {
        main: [
            {
                "name": "入場券の予約",
                "mobile_value": "http://www.chuanloo.com/m/#/market?dex=0",
                "child": [
                    {
                        "name": "機動遊具",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/ticket-detail.html?goods_id=230",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=230",
                    },
                    {
                        "name": "機動観覧席",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/ticket-detail.html?goods_id=166",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=166",
                    },
                    {
                        "name": "童話動物園",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/ticket-detail.html?goods_id=167",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=167",
                    },
                    {

                        "name": "ハッピーホームセット",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/ticket-detail.html?goods_id=190",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=190",
                    }
                ]
            },
            {
                "name": "ホテル予約",
                "mobile_value": "http://www.chuanloo.com/m/#/market?dex=1",
                "child": [
                    {
                        "name": "特色ある田園住宅",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=202",
                    },
                    {
                        "name": "異色の馬車小屋",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=195",
                    },
                    {

                        "name": "水郷风情房",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=196",
                    },
                    {

                        "name": "複式ホームスイートルーム",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/hotelOrder.html",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=198",
                    }
                ]
            },
            {
                "name": "長鹿年カード",
                "mobile_value": "http://www.chuanloo.com/m/#/market?dex=2",
                "child": [
                    {
                        "name": "シングルカード",
                        "mobile_value": "http://#",
                    },
                    {
                        "name": "カップルカード",
                        "mobile_value": "http://#",
                    },
                    {
                        "name": "家庭年カード",
                        "mobile_value": "http://#",
                    },
                    {
                        "name": "親子カード",
                        "mobile_value": "http://#",
                    }
                ]
            },
            {
                "name": "特恵販売",
                "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                "child": [
                    {

                        "name": "スイート・パッケージ",
                        "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                    },
                    {
                        "name": "海底船餐厅",
                        "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                    },
                    {
                        "name": "八角亭餐厅",
                        "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                    },
                    {
                        "name": "恐龙谷餐厅",
                        "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                    }
                ]
            }
        ],
        minor: [
            {name: "営業時間"},
            {name: "交通案内"},
            {name: "公園マップ"},
            {name: "提供情報"}],

    },
}
